import { Button, Input, Typography, message } from "antd";
import Card from "../../components/Card";
import { useState } from "react";
import { AuthService } from "../../services/AuthService";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const NewStore = () => {
    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [store, setStore] = useState({
        storeId: 0,
        storeName: null,
        location: null,
    })

    const saveCategory = async () => {
        setLoading(true);
        let { storeName, location } = store;
        if (!storeName || !location) {
            messageApi.open({
                type: 'error',
                content: 'Ploteso fushat e shenuara me *',
            });
            setLoading(false);
            return;
        }
        let res = await AuthService.createStore(store)
        if (res) {

            messageApi.open({
                type: 'success',
                content: 'Vlera u ruajt me sukses',
            });
            setTimeout(() => {
                setLoading(false);
                navigate(`/stores`);
            }, 1000);
        }
    }


    return (
        <div className="container">
            {contextHolder}
            <div className="row">
                <div className="col-lg-8">
                    <Card title="Add new store">
                        <form action="">
                            <div className="row">
                                <div className="col-12">
                                    <Text>Emri i pikes shitese *</Text>
                                    <Input value={store?.storeName} onChange={(e) => setStore({ ...store, storeName: e.target.value })} />
                                </div>
                                <div className="col-12 mt-3">
                                    <Text>Lokacioni *</Text>
                                    <Input value={store?.location} onChange={(e) => setStore({ ...store, location: e.target.value })} />
                                </div>
                                <div className="col-12 mt-3">
                                    <div className="d-flex justify-content-end">
                                        <Button type="primary" loading={loading} disabled={loading} onClick={saveCategory}>Ruaj shitoren</Button>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </Card>
                </div>
            </div>
        </div>
    )
}


export default NewStore;